import React, { Component } from "react";
import * as Containers from "../components/containers";
import Noise from "../components/noise";
import EPNHead from "../components/head";
import Circle from "../components/circle";
import Posts from "../functions/posts";
import { Link } from "react-router-dom";
import { SingleThumb } from "../components/single";
import buildLink from "../functions/buildlink";
import * as Scroll from "react-scroll";
import FaChevronDown from "react-icons/lib/fa/chevron-down";
import Compromisos from "../layout/compromisos";
import Sharers from "../components/sharers";
import YouTube from "react-youtube";
import FaPlay from "react-icons/lib/fa/play";
export class HomePage extends Component {
  state = {
    player: null,
    showoverlay: true,
    height: 0,
    width: 0
  };
  constructor(props) {
    super(props);
    this.onReady = this.onReady.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  onReady(event) {
    this.setState({
      player: event.target
    });
  }
  playVideo() {
    this.state.player.playVideo();
    this.setState({
      showoverlay: false
    });
  }
  componentDidMount() {
    window.scroll(0, 0);
    setTimeout(function() {
      window.scroll(0, 0);
    }, 1000);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  render() {
    const opts = {
      height: window.innerWidth * 0.56,
      width: window.innerWidth,
      playerVars: {
        autoplay: 0
      }
    };
    return (
      <Containers.Container classes={[]} contentTitle="">
        <Sharers />
        <Cover />
        <Containers.Section className="singles">
          {Posts.map(function(post) {
            return (
              <SingleThumb
                title={post.title}
                slug={post.slug}
                bg={post.photo.uri}
              />
            );
          })}
        </Containers.Section>
        <Containers.Section id="video">
          {this.state.showoverlay ? (
            <div className="video-overlay" onClick={() => this.playVideo()}>
              <div className="video-icon">
                <FaPlay size={35} color="white" />
              </div>
              <div className="video-overlay-texture" />
              <div
                className="video-overlay-bg"
                style={{
                  backgroundImage: "url(" + require("../img/mainbg.gif") + ")"
                }}
              />
              <div className="video-overlay-texture last" />
            </div>
          ) : null}
          <YouTube
            videoId="kcS3nliXQLc"
            onReady={event => this.onReady(event)}
            ref={player => (this.player = player)}
            opts={{
              width: this.state.width,
              height: this.state.width * 0.5625
            }}
          />
        </Containers.Section>
        <Intro />
        <Compromisos />
      </Containers.Container>
    );
  }
}
class Cover extends Component {
  render() {
    return (
      <Containers.Section full id="front">
        <a href="https://animalpolitico.com" target="_blank">
          <div className="logoAp">
            <img src={require("../img/mono.svg")} />
          </div>
        </a>
        <div
          id="gobottom"
          onClick={() => Scroll.animateScroll.scrollTo(window.innerHeight)}
        >
          <FaChevronDown size={24} color="white" />
        </div>
        <Circle />
        <Noise />
        <div className="front-title">
          <div className="title-container">
            <div className="front-title-s">
              Peña Nieto <span className="white">firmó.</span>
            </div>
            <div className="front-title-l">¿cumplió?</div>
          </div>
        </div>
        <EPNHead />
      </Containers.Section>
    );
  }
}
class Intro extends Component {
  render() {
    return (
      <Containers.Section id="intro">
        <div className="intro-p">
          <p>
            En la campaña de 2012, Enrique Peña Nieto prometió que, de ganar la
            Presidencia, transformaría México. Se dedicó a llevar ese mensaje a
            cada estado del país y firmó ante notario público 266 compromisos
            con los que, dijo, lograría la meta.
          </p>
          <p>
            Recuperar la paz, eliminar la pobreza, mejorar la educación,
            impulsar el crecimiento económico y llevar al país al liderazgo
            internacional se convirtieron en los ejes de la transformación que
            prometió.{" "}
          </p>
          <p>
            A seis años de distancia, el presidente dice que cumplió. En Animal
            Político te necesitamos para confirmarlo o saber si esos compromisos
            fueron solo una promesa de campaña.
          </p>
          <p>
            ¿Qué prometió Peña Nieto para tu estado? Te presentamos la lista de
            los 266 compromisos y el estatus que, según Presidencia, tiene cada
            uno. ¿Sabes o has visto algo? ¿Esa carretera, hospital u obra
            inaugurada en realidad no opera? ¿tiene fallas? ¿está inconcluso?
            Envía la información que tengas y ayúdanos a revisarlo.
          </p>
        </div>
        <Noise />
        <img src={require("../img/pena.png")} className="intro-img" />
      </Containers.Section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/index.jsx